import { createReducer, on } from '@ngrx/store';
import { SetPasswordState, initialSetPasswordState } from './state';
import {
  setPassword,
  requestSuccess,
  requestError,
  clearPassword,
} from './actions';

export const setPasswordReducer = createReducer(
  initialSetPasswordState,
  on(setPassword, (state): SetPasswordState => {
    return { ...state, loading: true };
  }),
  on(requestSuccess, (state, { response }): SetPasswordState => {
    return {
      error: false,
      loading: false,
      response: response,
    };
  }),
  on(requestError, (state, { error }): SetPasswordState => {
    return {
      error: error,
      loading: false,
      response: null,
    };
  }),
  on(clearPassword, (state): SetPasswordState => {
    return {
      error: false,
      loading: false,
      response: null,
    };
  })
);
